import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  // [HIGH-22] Gate on the auth `loading` flag before deciding to redirect.
  // On a cold load / hard refresh with an expired access token, AuthContext
  // performs an async refresh during which `user` is momentarily null. Without
  // this guard PrivateRoute would immediately bounce an authenticated designer
  // to /login. Show a loader until auth resolves, THEN decide.
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500" />
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

export default PrivateRoute;